import { Media } from 'ca-api-client';

export const versionActions = {
    async revertVersion({ commit }, payload) {
        const media = await Media.$find(payload.id);
        const result = await media._update({ file_id: payload.file_id });
        const file = result.files.data.filter((item) => item.uuid === payload.file_id);
        result.file = file.pop();
        result.timestamp = new Date().getTime();
        return result;
    },
};
